// src/environments/environment.ts
import { Environment } from './environment.model';
export const environment: Environment = {
    production: false,
    stage: 'PROD',
    region: 'EMEA',
    apiBaseUrls: {
        EMEA: 'https://r5285v74yl.execute-api.eu-west-1.amazonaws.com/fcl/v1'
    },
    cognitoConfigs: {
        EMEA: {
            aws_project_region: 'eu-west-1',
            aws_cognito_region: 'eu-west-1',
            aws_user_pools_id: 'eu-west-1_f1qv1HNpJ',
            aws_user_pools_web_client_id: '1ufgej2pqj74sgvs72qevvq1ga'
        }
    },
    zuoraEntity: ['EMEA', 'MAS_EMEA', 'IAP', 'MAS_IAP']
};